import { Form, Upload, UploadFile } from "antd";
import { useCallback } from "react";
import { useDownloadAttachment } from "../../../../lib/hooks/useDownloadAttachment";
import WorkTasksService from "../../../../services/workTasks";

type FileFormItemProps = {
  id: string;
};

export const FileFormItem = ({ id }: FileFormItemProps) => {
  const { isLoading, onDownload } = useDownloadAttachment(WorkTasksService);

  const onDownlaodClick = useCallback(
    (file: UploadFile) => {
      onDownload(id, file.name);
    },
    [onDownload, id],
  );

  return (
    <Form.Item
      name="file"
      className="w-100 mb-4"
      valuePropName="fileList"
      getValueFromEvent={(e) => e.fileList}
      label="Attachment"
    >
      <Upload
        listType="picture"
        maxCount={1}
        showUploadList={{ showDownloadIcon: true, showRemoveIcon: false }}
        previewFile={async () => ""}
        onDownload={onDownlaodClick}
        disabled={isLoading}
      />
    </Form.Item>
  );
};
